import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCheckmark = /*@__PURE__*/ proxyCustomElement(class CosmosIconCheckmark extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '57ad1b1d57eab90d1b63acdab9797043bafcb774', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'eb3da7fc6ed005e8b39a8e5bea59fc5769a3a2cc', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9873a09b638f8671e84cac06283c1db5867fb725', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.13 17.14a.5.5 0 0 1-.369-.126L3.298 13a.5.5 0 0 1-.037-.706l.334-.372a.5.5 0 0 1 .707-.037l3.74 3.363 9.596-10.232a.5.5 0 0 1 .707-.023l.365.342a.5.5 0 0 1 .022.707L8.472 16.983a.5.5 0 0 1-.341.158", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-checkmark", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-checkmark"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-checkmark":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCheckmark);
            }
            break;
    } });
}

export { CosmosIconCheckmark as C, defineCustomElement as d };
